import { Map } from 'immutable';

import { addProfileId, shapeNewProductForAPI, shapeOperationsForAPI } from './shapeForAPI';
import { canBeScheduled } from './statuses';
import { isVelaStatus } from '../listings/statuses';
import { getSize } from '../iterable/getSize';

import { EBAY, ETSY, FAIRE, SHOPIFY } from '../../constants/channels';
import { NEW, OPERATIONS } from '../../constants/product';
import { EMPTY } from '../../constants';

const OPERATIONS_KEY = {
  [true]: 'newProducts',
  [false]: 'productsToEdit',
};

export function shapeProductOperations({ product, scheduleAt }) {
  const channel = product.get('channel');
  const productId = product.get('productId');

  let operations = product.get('operations', EMPTY.LIST);

  if (scheduleAt !== undefined && canBeScheduled(product)) {
    operations = operations.push(Map({ type: OPERATIONS[channel].SCHEDULED_AT, value: scheduleAt }));
  }

  return shapeOperationsForAPI({ data: { products: [productId] }, operations });
}

export function shapeLinkedProductsOperations({
  linkId,
  products,
  scheduleAt,
  shopId: currentShopId,
  statuses,
  userFeatures,
  userShops,
}) {
  function reduceProducts(result, product, shopId) {
    const shop = userShops.getIn(['byId', shopId]);
    const db = shop.get('db');
    const channel = shop.get('channel');
    const isNew = product.get('productId') === NEW;
    const key = OPERATIONS_KEY[isNew];

    if (!result[key]) {
      result[key] = {};
    }

    if (!result[key][channel]) {
      result[key][channel] = [];
    }

    function getOperations() {
      const status = statuses.get(shopId);
      const operations = isNew
        ? shapeNewProductForAPI({ product, scheduleAt, shopId, status: statuses.get(shopId), userFeatures })
        : shapeProductOperations({ product, scheduleAt });

      function mapEtsyOperations(operation) {
        operation.shopId = shopId;
        operation.linkId = linkId;
        operation.db = db;

        return isNew
          ? addProfileId({ operation, product })
          : operation;
      }

      switch (channel) {
        case EBAY:
        case FAIRE: {
          const operation = { db, linkId, operations, saveOnly: isVelaStatus({ channel, status }), shopId };
          return isNew
            ? [addProfileId({ operation, product })]
            : [operation];
        }

        case ETSY: {
          if (getSize(operations) > 0) {
            return operations.map(mapEtsyOperations);
          }

          if (!isNew && shopId === currentShopId) {
            return [mapEtsyOperations({})];
          }

          return [];
        }

        case SHOPIFY: {
          const operation = { db, linkId, operations, shopId };
          return isNew
            ? [addProfileId({ operation, product })]
            : [operation];
        }

        default: {
          return [];
        }
      }
    }

    const operations = getOperations();

    result[key][channel] = result[key][channel].concat(operations);

    return result;
  }

  return products.reduce(reduceProducts, {});
}
